<div class="map-wrapper"
     leaflet
     [leafletLayers]="useMarkerCluster ? [] : layers"
     [leafletOptions]="options"
     [leafletFitBounds]="fitBounds"
     [leafletMarkerCluster]="useMarkerCluster ? layers : []"
     [leafletMarkerClusterOptions]="markerClusterOptions"
     (leafletClick)="onMapClick($event)"
     (leafletMapReady)="onMapReady($event)">
</div>
